

precision highp float;

uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

in vec3 position;
in vec2 uv;
out vec2 coord;

void main()	{
  coord = uv;
  gl_Position =
    projectionMatrix *
    modelViewMatrix *
    vec4(position,1.);
}